var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/Cloud/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/configure-pane-collapsible.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["componentID", "caption"], 
[], 
function (l_componentID, l_caption, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("componentID", l_componentID);
frame.set("caption", l_caption);
var t_2 = "";t_2 += "\n<div data-component-id=\"";
t_2 += runtime.suppressValue(l_componentID, env.opts.autoescape);
t_2 += "\">\n    <strong>";
t_2 += runtime.suppressValue(l_caption, env.opts.autoescape);
t_2 += ":</strong>\n    <a class=\"cm-info-content\" href=\"#";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "paneID"), env.opts.autoescape);
t_2 += "\"></a>\n</div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("infoContent");
context.setVariable("infoContent", macro_t_1);
output += "\n\n";
var macro_t_3 = runtime.makeMacro(
["componentID", "title"], 
[], 
function (l_componentID, l_title, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("componentID", l_componentID);
frame.set("title", l_title);
var t_4 = "";t_4 += "\n<div data-component-id=\"";
t_4 += runtime.suppressValue(l_componentID, env.opts.autoescape);
t_4 += "\">\n    <h3>";
t_4 += runtime.suppressValue(l_title, env.opts.autoescape);
t_4 += "</h3>\n    <div class=\"cm-component-container\"></div>\n</div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_4);
});
context.addExport("component");
context.setVariable("component", macro_t_3);
output += "\n\n<div class=\"cm-configure\">\n    <section class=\"cm-summary\">\n        <div class=\"cm-info\">";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("info"))(env, context, frame, runtime, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
output += t_5;
output += "</div>\n        <div class=\"cm-pane-controls\">\n            ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("paneControls"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n        </div>\n    </section>\n\n    <section class=\"well cm-pane\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "paneID"), env.opts.autoescape);
output += "\">\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("pane"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\n        <div class=\"pane-buttons\">\n            ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("paneButtons"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\n        </div>\n    </section>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_info(env, context, frame, runtime, cb) {
var lineno = 16;
var colno = 32;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_paneControls(env, context, frame, runtime, cb) {
var lineno = 18;
var colno = 15;
var output = "";
try {
var frame = frame.push(true);
output += "<div class=\"btn-group\">\n                <a class=\"btn btn-sm btn-default\" role=\"button\" href=\"#";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "paneID"), env.opts.autoescape);
output += "\"\n                   title=\"Configure filters\" aria-pressed=\"false\" data-toggle=\"button\">\n                    <i class=\"fa fa-wrench\"></i>\n                </a>\n                <a class=\"btn btn-sm btn-danger cm-reset\" role=\"button\" title=\"Reset filters\" href=\"#\">\n                    <i class=\"fa fa-undo\"></i>\n                </a>\n                <a class=\"btn btn-sm btn-success cm-refresh\" role=\"button\" title=\"Reload data\" href=\"#\">\n                    <i class=\"fa fa-refresh\"></i>\n                </a>\n            </div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_pane(env, context, frame, runtime, cb) {
var lineno = 36;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_paneButtons(env, context, frame, runtime, cb) {
var lineno = 38;
var colno = 15;
var output = "";
try {
var frame = frame.push(true);
output += "<a href=\"#\" class=\"btn btn-xs btn-success cm-refresh\"><i class=\"fa fa-refresh\"></i> Reload data</a>\n            <a href=\"#\" class=\"btn btn-xs btn-danger cm-reset\"><i class=\"fa fa-undo\"></i> Reset panel</a>\n            <a href=\"#\" class=\"btn btn-xs btn-default cm-hide\">Hide panel</a>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_info: b_info,
b_paneControls: b_paneControls,
b_pane: b_pane,
b_paneButtons: b_paneButtons,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/configure-pane-collapsible.html"] , dependencies)